import React from 'react';
import { 
    List, 
    Datagrid, 
    TextField,
    ReferenceField,
    DateField,
    NumberField,
    BooleanField,
    usePermissions,
    useResourceContext,
    EditButton,
    Filter,
    SelectInput
} from 'react-admin';
import { processPermissions, isAdminUser } from "../../common/roleUtils";

const ConcessionFilter = (props) => (
    <Filter {...props} variant='outlined'>
        <SelectInput source='concession_type' choices={[
            { id: 'scholarship', name: 'Scholarship' },
            { id: 'sibling_discount', name: 'Sibling Discount' },
            { id: 'merit_based', name: 'Merit Based' },
            { id: 'financial_aid', name: 'Financial Aid' },
            { id: 'other', name: 'Other' },
        ]} />
        <SelectInput source='is_active' choices={[
            { id: '1', name: 'Active' },
            { id: '0', name: 'Inactive' },
        ]} />
    </Filter>
);

export const FeeConcessionList = props => {
    const { permissions } = usePermissions();
    const resource = useResourceContext();
    
    const propsObj = processPermissions(permissions, resource);
    const allowBulkActions = isAdminUser();
    
    return (
        <React.Fragment>
            <List 
                title="Fee Concessions" 
                {...props} 
                {...propsObj}
                filters={<ConcessionFilter />}
                sort={{ field: 'created_at', order: 'DESC' }}
            >
                <Datagrid rowClick={propsObj.hasEdit ? 'edit' : false} bulkActionButtons={allowBulkActions ? undefined : false}>
                    {propsObj.hasEdit && <EditButton />}
                    <TextField source="id" />
                    <ReferenceField source="enrollment_id" reference="student-enrollment" label="Enrollment" link="show">
                        <TextField source="enrollment_number" />
                    </ReferenceField>
                    <TextField source="concession_type" label="Type" />
                    <NumberField source="concession_percentage" label="Percentage %" />
                    <NumberField source="concession_amount" label="Amount" options={{ style: 'currency', currency: 'INR' }} />
                    <TextField source="reason" label="Reason" />
                    <BooleanField source="is_active" label="Active" />
                    <DateField source="approved_date" label="Approved Date" />
                    <ReferenceField source="approved_by" reference="user" label="Approved By">
                        <TextField source="username" />
                    </ReferenceField>
                </Datagrid>
            </List>
        </React.Fragment>
    )
}
